const StockCardInitialState = {
  stockCardOpen: false,
  stockCardId: "",
};

export default StockCardInitialState;
